import Modal from "../../common/components/Modal";
import useUpdatePackageModal from "./UpdatePackageModal.hook";
import Loader from "../../common/components/Loader";
import LabeledInput from "../../common/components/LabeledInput";
import BasicButton from "../../common/components/BasicButton";
import { Fragment } from "react";

interface UpdatePackageModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedPackageId: string;
}

export default function UpdatePackageModal({
  isOpen,
  onClose,
  selectedPackageId,
}: UpdatePackageModalProps) {
  const {
    models: { state, updateLoading, fetchLoading },
    operations: { onStateChange, onUpdate },
  } = useUpdatePackageModal(selectedPackageId, onClose);

  return (
    <Modal
      title={`포인트상품 ${selectedPackageId === "new" ? "추가" : "수정"}`}
      open={isOpen}
      onClose={onClose}
    >
      <div className="flex h-full flex-col items-center gap-5">
        {fetchLoading ? (
          <Loader />
        ) : (
          <Fragment>
            <LabeledInput
              label="충전될 포인트 (상품)"
              type="number"
              min="0"
              value={state.point}
              onChange={(event) => onStateChange(event, "point")}
            />
            <LabeledInput
              label="판매 금액"
              type="number"
              min="0"
              value={state.initialPrice}
              onChange={(event) => onStateChange(event, "initialPrice")}
            />
            <LabeledInput
              label="할인 후 금액"
              type="number"
              min="0"
              value={state.finalPrice}
              onChange={(event) => onStateChange(event, "finalPrice")}
            />
            <BasicButton
              text={
                updateLoading
                  ? ""
                  : `${selectedPackageId === "new" ? "추가" : "수정"}`
              }
              icon={updateLoading && <Loader />}
              onClick={onUpdate}
              className="mt-auto w-1/2"
            />
          </Fragment>
        )}
      </div>
    </Modal>
  );
}
